export const environment = {
    production:true,
    baseUrl:'https://api.workbiservices.com/dev'
}